var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDirectionArrow16({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_direction_arrow_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector - North",
    d: "M7.68,1.971Q8,1.143 8.32,1.971L12.512,12.82Q12.857,13.714 12.117,13.105L8,9.714L3.883,13.105Q3.143,13.714 3.488,12.82Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDirectionArrow16);
export default __webpack_public_path__ + "static/media/ic_direction_arrow_16.2aff620e9be37e0d62f38ec96ab34327.svg";
export { ForwardRef as ReactComponent };